<!-- ============================================================== -->
<!-- Page wrapper  -->
<!-- ============================================================== -->
<div class="page-wrapper"
  style="color: #8d97ad">
<!--[style.margin-top.px]="((layoutManager.mobileMode)?0:0) + ((!layoutManager.mobileMode && layoutManager.innerWidth<1389)?100:0)"-->

  <!-- ============================================================== -->
  <!-- Static Slider 10  -->
  <!-- ============================================================== -->
  <div class="banner-innerpage" style="background-image:url('../../assets/images/banner-bg3.jpg')">
    <div class="container">
      <!-- Row  -->
      <div class="row justify-content-center ">
        <!-- Column -->
        <div class="col-md-6 align-self-center text-center" data-aos="fade-down" data-aos-duration="1200">
          <h1 class="title">I nostri partner</h1>
          <h6 class="subtitle op-8">La nostre partnership ci permettono di eccellere su ogni fronte del settore</h6> </div>
        <!-- Column -->
      </div>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Static Slider 10  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Container fluid  -->
  <!-- ============================================================== -->
  <div class="container-fluid">
    <!-- ============================================================== -->
    <!-- Blog example  -->
    <!-- ============================================================== -->
    <div class="spacer">
      <div class="container">
        <!-- Row  -->
        <div class="row justify-content-center">
          <div class="col-md-7 text-center">
            <h2 class="title" style="color: #3e4555;">GROUP TRADERS</h2>
            <h6 class="subtitle">Con più di 20 anni di esperienza nel Trading, forniamo un servizio di integrazione ed assistenza ai traders adattando
              una specifica strategia per ogni cliente</h6>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-8">
            <!-- Blog  -->

            <div class="mini-spacer">
              <a href="#"><img src="../../../assets/images/grouptraders.jpg" alt="logo" class="img-fluid img-rounded"/></a>
              <ul class="text-uppercase m-t-40 list-inline font-13 font-medium">
                chi siamo
              </ul>
              <h2 class="title font-light">Group Traders è nato per guidare i traders neofiti verso una strategia operativa</h2>
              <p class="m-t-30 m-b-30">GROUP TRADERS è formato da professionisti che si occupano di fornire assistenza gratuita a tutti colori che si avvicinano per la prima volta
                al mondo del trading attraverso il nostro gruppo su telegram.</p>
              <a (click)="redirectGrouptaders()" href="javascript:void(0)" class="font-13">CONTINUA A LEGGERE</a>
            </div>
            <!-- Blog  -->
            <hr class="op-5" />
            <!-- Blog  -->
            <ul class="text-uppercase m-t-40 list-inline font-13 font-medium">
              strategia
            </ul>
            <h2 class="title font-light">Ogni cliente è unico</h2>
            <p class="m-t-30 m-b-30">Ogni cliente è unico. Ecco perché personalizziamo le nostre strategie per adattarle alle tue esigenze. Sia che si tratti di un intervento breve o più impegnativo, ascolteremo le tue richieste per preparare un piano d'azione personalizzato. </p>
            <a (click)="redirectGrouptaders()" href="javascript:void(0)" class="font-13">CONTINUA A LEGGERE</a>
            <hr class="op-5" />

            <!-- Blog -->
            <div class="bg-light feature20 up">
              <div class="container">
                <div class="row justify-content-center">
                  <div class="col-md-7 text-center">
                    <h2 class="title">Consulta il nostro sito</h2>
                    <h6 class="subtitle">scopri approfondimenti nel nostro sito web per saperne di più</h6>
                  </div>
                </div>
                <div class="row wrap-feature-20">
                  <div  class="col-lg-6" data-aos="flip-left" data-aos-duration="1200" style="margin: auto">
                    <div class="card">
                      <div class="row">
                        <div class="col-md-8">
                          <div class="card-body d-flex no-block">
                            <div class="m-r-20"><img src="../../../assets/images/logo-grouptraders.jpg"
                                                     alt="logo" width="55" class="rounded" /></div>
                            <div>
                              <h5 class="font-medium">GROUP TRADERS</h5>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 text-center">
                          <a href="javascript:void(0)" class="text-white linking bg-success-gradiant"
                             (click)="redirectGrouptaders()">Apri <i class="ti-arrow-right"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br><br>
        <hr class="op-5" />
        <br><br>

        <div class="row justify-content-center">
          <div class="col-md-7 text-center">
            <h2 class="title" style="color: #3e4555;">KLIMEX Capital Markets</h2>
            <h6 class="subtitle">Broker Klimex Capital Markets è un broker ECN con sede in Australia Sydney facente parte di un grande gruppo  Vantage International Group Limited  con sede legale nelle isole Cayman che permette di fare trading su Forex, indici, materie prime e criptovalute.</h6>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-8">
            <!-- Blog  -->
            <ul class="text-uppercase m-t-40 list-inline font-13 font-medium">
              chi siamo
            </ul>
            <h2 class="title font-light">Società</h2>
            <p class="m-t-30 m-b-30">Klimex Capital Markets fa di tutto per garantire la protezione dei fondi dei clienti, mantenendo i fondi dei clienti in un conto segregato con la National Australia Bank Australiana con rating AA, avente una capitalizzazione di mercato di $ 93 miliardi, i clienti hanno la sicurezza che i loro fondi siano sicuri e protetti. In aggiunta a questo abbiamo intrapreso una protezione aggiuntiva firmando una polizza assicurativa di indennizzo di $ 20 milioni con SJ Catlin e Lloyds di Londra.
              Klimex Capital Markets collabora con i migliori fornitori di liquidità di alto livello il che ha portato ad un'offerta premium di liquidità Forex garantendo cosi le esecuzioni degli ordini più trasparenti e accurate.</p>
            <a (click)="redirectKlimex()" href="javascript:void(0)" class="font-13">CONTINUA A LEGGERE</a>

            <hr class="op-5" />

            <!-- ============================================================== -->
            <!-- Container fluid  -->
            <!-- ============================================================== -->
            <div>
              <div class="container">
                <!-- Row -->
                <div class="row justify-content-center">
                  <div class="col-md-12 text-center"></div>
                  <div class="col-md-7 text-center">
                    <h2 class="title">Cosa offriamo</h2>
                    <h6 class="subtitle">Caratteristiche competitive su tutti i fronti</h6>
                  </div>
                </div>
                <!-- Row -->
                <div class="row m-t-30 p-t-30 client-box">
                  <!-- column  -->
                  <div class="col-lg-3 col-md-6">
                    <div class="d-flex no-block">
                      <div class="display-5"><i class="icon-Line-Chart "></i></div>
                      <div class="m-l-20">
                        <h1 class="font-light counter m-b-0">1:500</h1>
                        <h6 class="text-muted font-13 text-uppercase">Leva</h6>
                      </div>
                    </div>
                  </div>
                  <!-- column  -->
                  <!-- column  -->
                  <div class="col-lg-3 col-md-6">
                    <div class="d-flex no-block">
                      <div class="display-5"><i class="icon-Coins"></i></div>
                      <div class="m-l-20">
                        <h1 class="font-light counter m-b-0">0.1</h1>
                        <h6 class="text-muted font-13 text-uppercase">Spreads da</h6>
                      </div>
                    </div>
                  </div>
                  <!-- column  -->
                  <!-- column  -->
                  <div class="col-lg-3 col-md-6">
                    <div class="d-flex no-block">
                      <div class="display-5"><i class="icon-Coin"></i></div>
                      <div class="m-l-20">
                        <h1 class="font-light counter m-b-0">100</h1>
                        <h6 class="text-muted font-13 text-uppercase">Depositio minimo</h6>
                      </div>
                    </div>
                  </div>
                  <!-- column  -->
                  <!-- column  -->
                  <div class="col-lg-3 col-md-6">
                    <div class="d-flex no-block">
                      <div class="display-5"><i class="icon-Trophy"></i></div>
                      <div class="m-l-20">
                        <h1 class="font-light counter m-b-0">70</h1>
                        <h6 class="text-muted font-13 text-uppercase">Assets</h6>
                      </div>
                    </div>
                  </div>
                  <!-- column  -->
                </div>
              </div>
            </div>
<br><br>



        <!-- Row  -->
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Blog example -->
    <!-- ============================================================== -->
  </div>
      <!-- ============================================================== -->
      <!-- Feature 5  -->
      <!-- ============================================================== -->
      <div class="bg-light spacer feature5">
        <div class="container">
          <!-- Row  -->
          <div class="row justify-content-center">
            <div class="col-md-7 text-center">
              <h2 class="title">Convezione per clienti Grouptraders-Klimex</h2>
              <h6 class="subtitle">Se sei cliente Klimex puoi usufruire di numerosi vantaggi nei nostri servizi</h6>
            </div>
          </div>
          <!-- Row  -->
          <div class="row m-t-40">
            <!-- Column -->
            <div class="col-md-4 wrap-feature5-box">
              <div class="card card-shadow" data-aos="fade-right" data-aos-duration="1200">
                <div class="card-body d-flex">
                  <div class="icon-space"><i class="text-success-gradiant icon-Coins"></i></div>
                  <div class="">
                    <h6 class="font-medium"><a href="javascript:void(0)" class="linking">Rimborso VPS</a></h6>
                    <p class="m-t-20">VPS gratuito per versamenti minimi di 3.000€ e 5 lotti negoziati al mese.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Column -->
            <!-- Column -->
            <div class="col-md-4 wrap-feature5-box">
              <div class="card card-shadow" data-aos="fade-down" data-aos-duration="1200">
                <div class="card-body d-flex">
                  <div class="icon-space"><i class="text-success-gradiant  icon-Add "></i></div>
                  <div class="">
                    <h6 class="font-medium"><a href="javascript:void(0)" class="linking">Margine extra </a></h6>
                    <p class="m-t-20">Somma che il broker mette a disposizione fin dal primo versamento che varia dal 10% al 25% del capitale depositato.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Column -->
            <!-- Column -->
            <div class="col-md-4 wrap-feature5-box">
              <div class="card card-shadow" data-aos="fade-left" data-aos-duration="1200">
                <div class="card-body d-flex">
                  <div class="icon-space"><i class="text-success-gradiant icon-Arrow-OutLeft "></i></div>
                  <div class="">
                    <h6 class="font-medium"><a href="javascript:void(0)" class="linking">Rimborso SWAP </a></h6>
                    <p class="m-t-20">Storno rimborso SWAP (su richiesta) mediante compensazione ogni fine mese per capitali minimi di 10.000€.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Column -->
            <!-- Column -->
            <div class="col-md-4 wrap-feature5-box">
              <div class="card card-shadow" data-aos="fade-right" data-aos-duration="1200">
                <div class="card-body d-flex">
                  <div class="icon-space"><i class="text-success-gradiant icon-Coin"></i></div>
                  <div class="">
                    <h6 class="font-medium"><a href="javascript:void(0)" class="linking">Basso Spread</a></h6>
                    <p class="m-t-20">Possibilità di operare con zero spread richiedendo il conto RAW.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Column -->
            <!-- Column -->
            <div class="col-md-4 wrap-feature5-box">
              <div class="card card-shadow" data-aos="fade-up" data-aos-duration="1200">
                <div class="card-body d-flex">
                  <div class="icon-space"><i class="text-success-gradiant icon-Target-Market"></i></div>
                  <div class="">
                    <h6 class="font-medium"><a href="javascript:void(0)" class="linking">Su misura </a></h6>
                    <p class="m-t-20">Disponibilità a valutare esigenze particolari e venire incontro al cliente attraverso mirate e personalizzate soluzioni.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Column -->
            <!-- Column -->
            <div class="col-md-4 wrap-feature5-box">
              <div class="card card-shadow" data-aos="fade-left" data-aos-duration="1200">
                <div class="card-body d-flex">
                  <div class="icon-space"><i class="text-success-gradiant   icon-Timer "></i></div>
                  <div class="">
                    <h6 class="font-medium"><a href="javascript:void(0)" class="linking">Supporto rapido</a></h6>
                    <p class="m-t-20">Supporto h/24 rapito ed efficiente.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================================== -->
  <!-- End Container fluid  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Back to top -->
  <!-- ============================================================== -->
  <a class="bt-top btn btn-circle btn-lg btn-info" href="#top"><i class="ti-arrow-up"></i></a> </div>
<!-- ============================================================== -->
<!-- End Page wrapper  -->
<!-- ============================================================== -->
